<template>
  <div class="market-page">
    <market-hero :market="anonMarket" />
    <b-container class="market-page__body">
      <b-row>
        <b-col lg="8" class="order-2 order-lg-1">
          <market-booking-card v-if="canBook" class="mb-4" />
          <market-app-card
            v-if="anonMarket.mobileAppAccess"
            :help-url="mobileAppHelpUrl"
            class="mb-4"
          />
          <market-gallery-card
            v-if="anonMarket.marketImages && anonMarket.marketImages.length"
            :images="anonMarket.marketImages"
            class="mb-4"
          />
          <market-card
            v-if="anonMarket.description || anonMarket.extraMarketInfo"
            :title="$t('pages.login.user.about_title', { name: anonMarket.visualName })"
            class="mb-4"
          >
            <p v-if="anonMarket.description" class="pre-wrap mb-0">{{ anonMarket.description }}</p>
            <p
              v-if="anonMarket.extraMarketInfo"
              class="pre-wrap text-muted mb-0"
              :class="{ 'mt-3': anonMarket.description }"
            >
              {{ anonMarket.extraMarketInfo }}
            </p>
          </market-card>
          <b-row>
            <b-col :md="hasOpeningHours ? 6 : 12" class="mb-4">
              <market-contact-card
                :market="anonMarket"
                :market-feedback="marketFeedback"
                class="h-100"
              />
            </b-col>
            <b-col v-if="hasOpeningHours" md="6" class="mb-4">
              <market-hours-card :market="anonMarket" class="h-100" />
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="4" class="order-1 order-lg-2 mb-4">
          <market-card class="market-login">
            <component v-bind:is="componentName" />
            <p
              v-if="!anonMarket.mobileAppAccess"
              class="small text-muted text-center mt-3 mb-0"
              v-html="$t('pages.login.user.download_app_help_text', { app_help_link: mobileAppHelpUrl })"
            ></p>
          </market-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import UserLogin from '@anonymous/components/user/UserLogin.vue'
  import UserResetPassword from '@anonymous/components/user/UserResetPassword.vue'
  import UserConfirmResetPassword from '@anonymous/components/user/UserConfirmResetPassword.vue'
  import UserEmailConfirm from '@anonymous/components/user/UserEmailConfirm.vue'
  import MarketGalleryCard from '@base/components/market/MarketGalleryCard.vue'
  import MarketCard from '@base/components/market/MarketCard.vue'
  import MarketHero from '@anonymous/components/market/MarketHero.vue'
  import MarketBookingCard from '@anonymous/components/market/MarketBookingCard.vue'
  import MarketAppCard from '@base/components/market/MarketAppCard.vue'
  import MarketContactCard from '@base/components/market/MarketContactCard.vue'
  import MarketHoursCard from '@base/components/market/MarketHoursCard.vue'
  import { mapState } from 'vuex'
  import { anonRequestInterceptor } from '@base/store'
  import { marketFeedback } from '@base/services'
  import { MOBILE_APP_HELP_URLS } from '@base/configs'


  marketFeedback.interceptors.request.use(anonRequestInterceptor)

  export default {
    name: 'AnonUserView',

    components: {
      UserLogin,
      UserResetPassword,
      UserConfirmResetPassword,
      UserEmailConfirm,
      MarketGalleryCard,
      MarketCard,
      MarketHero,
      MarketBookingCard,
      MarketAppCard,
      MarketContactCard,
      MarketHoursCard,
    },

    data () {
      return {
        marketFeedback: marketFeedback,
      }
    },

    props: {
      componentName: {
        type: String,
        required: true,
      },
    },

    computed: {
      ...mapState(['anonMarket']),

      mobileAppHelpUrl () {
        return MOBILE_APP_HELP_URLS[this.$i18n.locale.toUpperCase()] || MOBILE_APP_HELP_URLS.EN
      },

      canBook () {
        return Boolean(
          (this.anonMarket.gatewayApiValid || this.anonMarket.allowOfflinePayments)
          && this.anonMarket.onlineBookingFeature
          && this.anonMarket.customerAccessToBooking
          && this.anonMarket.showPaymentTerms
        )
      },

      hasOpeningHours () {
        return Boolean(
          (this.anonMarket.openingHours && this.anonMarket.openingHours.length)
          || this.anonMarket.openingHoursExtraInfo
        )
      },
    },
  }
</script>

<style scoped>
  .market-page__body {
    padding-top: 1.5rem;
  }

  @media (min-width: 992px) {
    .market-page__body {
      padding-top: 2rem;
    }

    .market-login {
      position: sticky;
      top: 72px;
    }
  }
</style>
